import type { ConfirmDialogProps } from './types';

import { useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

// ----------------------------------------------------------------------

export function ConfirmDialog({
  open,
  title,
  content,
  onClose,
  onConfirm,
  confirmText,
  cancelText = 'Cancel',
  confirmDisabled = false,
  ...other
}: ConfirmDialogProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}>{content}</DialogContent>}

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose} disabled={isLoading}>
          {cancelText}
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          loading={isLoading}
          disabled={confirmDisabled || isLoading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
